/**
 * Configurable per-rule weights for the Quality Score. Defaults below; users can
 * override them in Settings → Quality Scoring (persisted in localStorage).
 */

export type QualityWeights = Record<string, number>;

export const DEFAULT_QUALITY_WEIGHTS: QualityWeights = {
  zero_price_nonzero_cost: 15,
  price_below_cost: 15,
  negative_margin: 15,
  low_margin: 8,
  nonzero_price_zero_cost: 5,
  stale_pricing: 5,
  missing_manufacturer: 3,
  dirty_vendor_sku: 3,
  negative_inventory: 5,
  duplicate_product_id: 10,
};

export const RULE_LABELS: Record<string, string> = {
  zero_price_nonzero_cost: "Zero price, non-zero cost",
  price_below_cost: "Price below cost",
  negative_margin: "Negative margin",
  low_margin: "Low margin",
  nonzero_price_zero_cost: "Non-zero price, zero cost",
  stale_pricing: "Stale pricing",
  missing_manufacturer: "Missing manufacturer",
  dirty_vendor_sku: "Dirty vendor SKU",
  negative_inventory: "Negative inventory",
  duplicate_product_id: "Duplicate product ID",
};

export const RULE_IDS = Object.keys(DEFAULT_QUALITY_WEIGHTS);

const STORAGE_KEY = "catalogkit.qualityWeights";

export function loadQualityWeights(): QualityWeights {
  const merged: QualityWeights = { ...DEFAULT_QUALITY_WEIGHTS };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return merged;
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    for (const [key, value] of Object.entries(parsed)) {
      if (typeof value === "number" && Number.isFinite(value)) merged[key] = value;
    }
  } catch {
    // Fall back to defaults.
  }
  return merged;
}

export function saveQualityWeights(weights: QualityWeights): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(weights));
  } catch {
    // Storage unavailable — weights fall back to defaults next load.
  }
}
